// new component  with 

import { useAppDispatch, useAppSelector } from '@/common/reducers/hooks/store.hook';
import ResizableDrawer from './resizeable-drawer';
import TasksPanelDrawerContent from './tasks-panel-drawer-content';
import { taskActions } from '@/common/reducers/TasksReducer';
import { getCurrentBoard, isBoardPanelDrawerOpen } from '@common-reducers/BoardsSelectors';
import { DBBoardsThunks } from '@/common/reducers/DBServiceThunks';


export const BoardResizableDrawer = () => {
  const dispatch = useAppDispatch();
  const taskViewSideDrawerOpen = useAppSelector((state) => state.TasksReducer.taskViewSideDrawerOpen);
  const boardPanelDrawerOpen = useAppSelector((state) => isBoardPanelDrawerOpen(state))
  const board = useAppSelector(getCurrentBoard);
  const isExtraDataPanel = taskViewSideDrawerOpen === "ExtraDataPanel";

  const stopResize = (drawerWidth: number) => {
    if (!board?._id) return;
    dispatch(DBBoardsThunks.patch({
      entity: {
        _id: board._id,
        drawerWidth: drawerWidth
      }
    }));
  }


  return (
    <ResizableDrawer
      //boardPanelDrawerOpen
      isOpen={taskViewSideDrawerOpen !== ""}
      onClose={() => dispatch(taskActions.setTaskViewSideDrawerOpenWith(""))}
      drawerWidthProp={board?.drawerWidth}
      stopResize={stopResize}
      contentOverflow={isExtraDataPanel ? "hidden" : "auto"}
    >
      <TasksPanelDrawerContent />
    </ResizableDrawer>
  );
};
